// don't remove
import * as TapEventPlugin from '../common/TapEventPlugin'

import * as React from "react";
import {List, ListItem} from 'material-ui/List';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import RaisedButton from "material-ui/RaisedButton";
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

declare global {
    interface Window {
        initialState: any;
        app : any;
    }
}

export default class InstrumentsList extends React.Component<any, any> {
    userAgent : string;

    constructor(props: any) {
        super(props);
        let t = Object.keys(props).length > 0 ? this.props : window.initialState;
        t.dialogShown = false;
        this.state = t;
        this.userAgent = props.userAgent ? props.userAgent : navigator.userAgent;
    }

    // componentDidMount() {
    //     this.setState({tunings : [{"name" : 123}]});
    // }

    handleDialogOpen (event) {
        if (!window.app.userBar.ensureAuth()) return;
        this.setState({dialogShown: true});
    };

    handleDialogClose (event) {
        this.setState({dialogShown: false});
    };

    handleListItemClick (shortName) {
        location.href = "/chords/" + shortName + "/standard";
    };

    handleTuningsClick (shortName) {
        location.href = "/tunings/" + shortName;
        return false;
    };

    render() {
        const {instruments} = this.state;
        const items = instruments.map(t => {
            return <ListItem key={t.name} primaryText={<a href={"/chords/" + t.shortName + "/standard"}>{t.name}</a>} secondaryText={t.strings + " strings"}
                             onTouchTap={this.handleListItemClick.bind(this, t.shortName)}
                             rightIconButton={
                                 <RaisedButton label="Tunings..." onClick={this.handleTuningsClick.bind(this, t.shortName)} />
                             } />
        });


        return <MuiThemeProvider muiTheme={getMuiTheme({userAgent: this.userAgent })}>
            <div>
                <List>
                    {items}
                </List>

                <p>
                    <a href="mailto:chords@songtive.com?subject=New instrument suggestion" className="btn btn-warning">Suggest missing instrument</a>
                </p>
            </div>
        </MuiThemeProvider>
    }
}


// WEBPACK FOOTER //
// ./components/guitar/InstrumentsList.tsx